import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthService from '../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
  resourceType?: string;
}

/**
 * Component bảo vệ route, ngăn người dùng không có quyền truy cập
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole, 
  resourceType 
}) => {
  const currentUser = AuthService.getCurrentUser();
  
  // Nếu chưa đăng nhập hoặc token hết hạn, chuyển hướng về trang đăng nhập
  if (!currentUser || AuthService.isTokenExpired()) {
    if (AuthService.isTokenExpired()) {
      console.log('Token đã hết hạn, đang logout...');
      AuthService.logout();
    }
    return <Navigate to="/auth/login" replace />;
  }
  
  // Nếu cần vai trò cụ thể và người dùng không có vai trò đó
  if (requiredRole && currentUser.role !== requiredRole) {
    // Nếu người dùng là staff, chuyển hướng về trang orders của staff
    if (currentUser.role === 'staff') {
      return <Navigate to="/staff/orders" replace />;
    }
    // Nếu là admin hoặc vai trò khác, chuyển hướng về dashboard
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  // Nếu cần kiểm tra quyền truy cập tài nguyên
  if (resourceType && !AuthService.hasPermission(resourceType)) {
    // Nếu người dùng là staff, chuyển hướng về trang orders của staff
    if (currentUser.role === 'staff') {
      return <Navigate to="/staff/orders" replace />;
    }
    // Nếu là admin hoặc vai trò khác, chuyển hướng về dashboard
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  return <>{children}</>;
};

export default ProtectedRoute; 